import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'taskState'
})
export class TaskStatePipe implements PipeTransform {

  transform(state: number, args?: any): any {
    if (state === -10) {
      return 'pending';
    }

    if (state === -2) {
      return 'cancelled';
    }

    if (state === -1) {
      return 'error';
    }

    if (state === 0) {
      return 'finished';
    }

    if (state > 0) {
      return 'active';
    }

    // Unknown state
    return 'pending';
  }

}
